export default __webpack_public_path__ + "static/media/integracao_btg_exterior.b48b1d0d.gif";